import React from "react";
import "./websiteBuilderDragLayer.scss";
import { useDragLayer } from "react-dnd";
import { IWebsiteBuilderElementDataBase, TWebsiteBuilderElement } from "../nodes/element/websiteBuilderElement";
import { websiteBuilderZLayers } from "../websiteBuilderZLayers";

export function WebsiteBuilderDragLayer() {
  const { isDragging, clientOffset, item } = useDragLayer(monitor => {
    return {
      isDragging: monitor.isDragging(),
      clientOffset: monitor.getClientOffset(),
      item: monitor.getItem(),
    };
  });

  if (!isDragging || !clientOffset || !item || item.type !== "element") {
    return null;
  }

  const element: IWebsiteBuilderElementDataBase = (item as TWebsiteBuilderElement).element;

  const width = element.dimensions.width;
  const height = element.dimensions.height;

  const left = clientOffset.x - width / 2;
  const top = clientOffset.y - height / 2;

  return (
    <div
      className="website-builder-drag-layer"
      style={{
        width,
        height,
        left,
        top,
        zIndex: websiteBuilderZLayers.dragLayer,
      }}
    />
  );
}
